import React from "react";
import masterData from "../../lib/masterData";

const wait = (delay) => new Promise((resolve) => setTimeout(() => resolve(), delay));

export class MasterDataReady extends React.Component {
  constructor(props) {
    super(props);
    const { schemaIds } = props;
    if (
      (schemaIds && masterData.prepared(schemaIds)) ||
      (!schemaIds && masterData.preparedAll())
    ) {
      this.state = { prepared: true };
    } else {
      this.state = {};
      this.prepare(props.schemaIds);
    }
  }
  componentWillMount() {
    this.mounted = true;
  }
  async prepare(schemaIds) {
    if (this.props.delay) {
      await wait(this.props.delay);
    }
    if (schemaIds) {
      await masterData.prepare(schemaIds);
    } else {
      await masterData.prepareAll();
    }
    if (this.mounted) {
      this.setState({ prepared: true });
    } else {
      this.state = Object.assign({}, this.state, { prepared: true });
    }
  }
  render() {
    if (this.state.prepared || this.props.forceRender) {
      if (this.props.render) {
        return this.props.render(masterData);
      } else {
        return this.props.children;
      }
    } else {
      /* eslint-disable no-lonely-if */
      if (this.props.loading) {
        return this.props.loading();
      } else {
        return <div className="loading">loading</div>;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./lib/masterData/MasterDataReady.jsx